module.exports = __webpack_public_path__ + "img/anxiety-icon-1.eaf6e92a.svg";